import { create } from 'zustand';
import { authAPI } from '../services/api';

const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  isAuthenticated: !!localStorage.getItem('user'),
  loading: false,
  error: null,

  login: async (credentials) => {
    set({ loading: true, error: null });
    try {
      const response = await authAPI.login(credentials);
      const { user } = response.data.data;

      localStorage.setItem('user', JSON.stringify(user));

      set({
        user,
        isAuthenticated: true,
        loading: false
      });

      return { success: true };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Login failed';
      set({ loading: false, error: errorMessage });
      return { success: false, error: errorMessage };
    }
  },

  logout: async () => {
    try {
      await authAPI.logout();
    } catch (e) {
      // Ignore logout API errors
    }
    localStorage.removeItem('user');
    set({
      user: null,
      isAuthenticated: false
    });
  },

  register: async (data) => {
    set({ loading: true, error: null });
    try {
      const response = await authAPI.register(data);
      const { user } = response.data.data;

      localStorage.setItem('user', JSON.stringify(user));

      set({
        user,
        isAuthenticated: true,
        loading: false
      });

      return { success: true };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Registration failed';
      set({ loading: false, error: errorMessage });
      return { success: false, error: errorMessage };
    }
  }
}));

export default useAuthStore;
